import Glider from 'glider-js/glider'; 

export default () => {
    let gliderGallery = document.querySelectorAll('.js-carousel');
    if (gliderGallery){ 
      gliderGallery.forEach(element => {
            let initGlider = new Glider(element, {
                slidesToShow: 1,
                draggable: true,
                resizeLock: true,
                scrollLock: true,
            });
            initGlider.setOption({
                arrows: {
                    prev: element.nextElementSibling.querySelector('.js-carousel-prev.glider-prev'),
                    next: element.nextElementSibling.querySelector('.js-carousel-next.glider-next'),
                },
                responsive: [
                  { 
                    breakpoint: 640,
                      settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                      }
                  },
                  { 
                    breakpoint: 1024,
                      settings: {
                        slidesToShow: 4,
                        slidesToScroll: 1
                      }
                    }
                  ]
            });

            initGlider.refresh(true);
            let nav = element.parentElement.querySelector('.js-carousel-nav');
            if (initGlider.opt.slidesToShow >= +element.dataset.cardsNumber) {
              nav.classList.add('no-arrows')
            }
            window.addEventListener('resize', () =>{
              if (initGlider.opt.slidesToShow >= +element.dataset.cardsNumber) {
                nav.classList.add('no-arrows')
              } else {
                nav.classList.remove('no-arrows')
              }
            })

        });

    }
}